var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 7,
    y: 7,
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1011_8533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 4.16732C1.43687 4.16732 1.25033 4.35387 1.25033 4.58398V8.33398C1.25033 8.5641 1.43687 8.75065 1.66699 8.75065H5.41699C5.64711 8.75065 5.83366 8.5641 5.83366 8.33398V4.58398C5.83366 4.35387 5.64711 4.16732 5.41699 4.16732H1.66699ZM0.416992 4.58398C0.416992 3.89363 0.976636 3.33398 1.66699 3.33398H5.41699C6.10735 3.33398 6.66699 3.89363 6.66699 4.58398V8.33398C6.66699 9.02434 6.10735 9.58398 5.41699 9.58398H1.66699C0.976636 9.58398 0.416992 9.02434 0.416992 8.33398V4.58398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33301 1.24935C8.44351 1.24935 8.5495 1.29325 8.62764 1.37139C8.70578 1.44953 8.74967 1.55551 8.74967 1.66602V5.41602C8.74967 5.52652 8.70578 5.6325 8.62764 5.71064C8.5495 5.78878 8.44351 5.83268 8.33301 5.83268H7.91634C7.68622 5.83268 7.49967 6.01923 7.49967 6.24935C7.49967 6.47947 7.68622 6.66602 7.91634 6.66602H8.33301C8.66453 6.66602 8.98247 6.53432 9.21689 6.2999C9.45131 6.06548 9.58301 5.74754 9.58301 5.41602V1.66602C9.58301 1.3345 9.45131 1.01655 9.21689 0.782132C8.98247 0.547712 8.66453 0.416016 8.33301 0.416016H4.58301C4.25149 0.416016 3.93355 0.547712 3.69912 0.782132C3.4647 1.01655 3.33301 1.33449 3.33301 1.66602V2.08268C3.33301 2.3128 3.51956 2.49935 3.74967 2.49935C3.97979 2.49935 4.16634 2.3128 4.16634 2.08268V1.66602C4.16634 1.55551 4.21024 1.44953 4.28838 1.37139C4.36652 1.29325 4.4725 1.24935 4.58301 1.24935H8.33301Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1011_8533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.da0de2f037c5b0d673f6058b8192840d.svg";
export { ForwardRef as ReactComponent };